import {Field} from 'formik';
import {FormikTextInput} from '@flexinet/ui-components';

export const FilterFormComponent = () => {
    return (
        <>
            <Field
                name="namePrefix"
                label="Name Prefix"
                description="Filter repositories by name prefix"
                component={FormikTextInput}
                my="md"
            />
        </>
    );
};
